// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatFeedbackPrivacy-moduleprivacy___YBcH";
export { _1 as "privacy" }
